import request from './ajax'

const signUrl = '/api/sign/' // 签到模块
// 获取本周签到记录
export const getSignRecord = (data) => request(signUrl + 'sign_record', 'post', { ...data, openLoding: 1 })
// 获取签到规则
export const getSignRule = (data) => request(signUrl + 'sign_rule', 'post', { ...data, openLoding: 1 })
// 签到有礼详情
export const getSignDetail = (data) => request(signUrl + 'info', 'post', { ...data, openLoding: 1 })
// 发起签到
export const setSign = (data) => request(signUrl + 'sign', 'post', { ...data, openLoding: 1 })
// 查看更多优惠卷
export const getMoreCoupon = (data) => request(signUrl + 'more_coupon', 'post', { ...data, openLoding: 1 })
